import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ButtonTemplate from '../ButtonTemplate';
import style from './styles/style.module.css';

class WhiteButton extends PureComponent {
    render() {
        var props = { ...this.props };
        props.className = `${ this.props.className } ${ style.whiteButton }`.trim();
        props.labelClass = style.label;
        props.effectClass = style.effect;
        props.backgroundClass = style.backgroundColor;
        props.showEffect = false;
        return (
            <ButtonTemplate { ...props } />
        );
    }
}
WhiteButton.propTypes = {
    label: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ).isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
};
WhiteButton.defaultProps = {
    label: '',
    className: '',
    onClick: () => {},
};

export default WhiteButton;
